export const buildCsv = (phones, params, includeCode = false) => {
  const headerVars = Object.keys(params.header || {});
  const bodyVars = Object.keys(params.body || {});
  const buttonVars = Object.keys(params.button || {});
  const varNames = [...headerVars, ...bodyVars, ...buttonVars];

  const csvHeader = ['receiver_phone_number', ...varNames, ...(includeCode && params.code ? ['code'] : [])];
  const escapeCsv = (val) => {
    if (val === undefined || val === null) return '';
    const str = String(val);
    return `"${str.replace(/"/g, '""')}"`;
  };

  const csvRows = phones.map(phone => {
    const row = [
      escapeCsv(phone),
      ...varNames.map(v => escapeCsv(params.header?.[v] ?? params.body?.[v] ?? params.button?.[v] ?? '')),
      ...(includeCode && params.code ? [escapeCsv(params.code)] : [])
    ];
    return row.join(',');
  });

  return [csvHeader.join(','), ...csvRows].join('\n');
};
